(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mc-dispatch-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
    function parisToday() {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date());
      const part = name => Number(parts.find(item => item.type === name).value);
      return new Date(Date.UTC(part('year'), part('month') - 1, part('day'), 12));
    }

    function estimatedDate(today) {
      const result = new Date(today);
      let businessDays = 0;
      while (businessDays < 2) {
        result.setUTCDate(result.getUTCDate() + 1);
        const weekday = result.getUTCDay();
        if (weekday !== 0 && weekday !== 6) businessDays += 1;
      }
      return result;
    }

    function update(root) {
      const today = parisToday();
      let dispatch = estimatedDate(today);
      const override = root.dataset.dispatchOverride;
      if (/^\d{4}-\d{2}-\d{2}$/.test(override || '')) {
        const manualDate = new Date(override + 'T12:00:00Z');
        if (!Number.isNaN(manualDate.getTime()) && manualDate >= today) dispatch = manualDate;
      }
      const includeYear = dispatch.getUTCFullYear() !== today.getUTCFullYear();
      const formatOptions = { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'long' };
      if (includeYear) formatOptions.year = 'numeric';
      const formatted = new Intl.DateTimeFormat('fr-FR', formatOptions).format(dispatch);
      const iso = dispatch.toISOString().slice(0, 10);
      const time = document.createElement('time');
      time.dateTime = iso;
      time.textContent = formatted;
      root.querySelector('[data-mc-dispatch-copy]').replaceChildren(
        document.createTextNode('Expédition estimée le '), time
      );
    }

    function initialise() {
      document.querySelectorAll('[data-mc-dispatch-estimate]').forEach(root => {
        if (root.dataset.mcDispatchReady) return;
        root.dataset.mcDispatchReady = 'true';
        const wrapper = root.parentElement;
        const syncAvailability = () => {
          const button = wrapper.querySelector('.mc-bundle__button') || wrapper.querySelector('button[name="add"]');
          root.hidden = !button || button.disabled;
        };
        update(root);
        syncAvailability();
        new MutationObserver(syncAvailability).observe(wrapper, {
          attributes: true, attributeFilter: ['disabled', 'data-unavailable'],
          childList: true, subtree: true
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialise);
    } else {
      initialise();
    }
    document.addEventListener('shopify:section:load', initialise);
    window.setInterval(() => {
      document.querySelectorAll('[data-mc-dispatch-estimate]').forEach(update);
    }, 60000);
  })();
  } catch(e) { console.error(e); }
})();

})();
